import React, { useState, useEffect } from "react";
import axios from "axios";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { FaBookmark, FaUserCircle, FaHome } from "react-icons/fa";
import { FaUser, FaFileLines, FaBuilding } from "react-icons/fa6";
import { FiLogOut } from "react-icons/fi";
import Logo from "../images/logo.png";
import { buildApiUrl } from "../utils/api";

const navLinks = [
    { to: "/marketerDetails", label: "Dashboard", icon: <FaHome />, exact: true },
    { to: "/marketerDetails/commonEnquiryList", label: "Contact Enquiries", icon: <FaUser /> },
    { to: "/marketerDetails/userBookingList", label: "Quote Requests", icon: <FaFileLines /> },
    { to: "/marketerDetails/warehouseEnquiryList", label: "Buyer Briefs", icon: <FaBookmark /> },
    { to: "/marketerDetails/clientEnquiryList", label: "Provider Applications", icon: <FaBuilding /> },
];

function MarketerMenu() {
    const [userName, setUserName] = useState("");
    const navigate = useNavigate();
    const { pathname } = useLocation();

    useEffect(() => {
        const fetchUserDetails = async () => {
            try {
                const token = localStorage.getItem("token");
                if (!token) return;

                const res = await axios.get(buildApiUrl("/api/marketer/marketerDetails"), {
                    headers: { Authorization: `Bearer ${token}` }
                });

                if (res.data?.user) {
                    setUserName(res.data.user.name || "");
                }
            } catch (error) {
                console.error("Error fetching marketer details:", error);
            }
        };
        fetchUserDetails();
    }, []);

    const handleLogout = () => {
        localStorage.removeItem("token");
        localStorage.removeItem("userType");
        navigate("/marketerLogin");
    };

    const isActive = (to, exact) =>
        exact ? pathname === to : pathname.startsWith(to);

    return (
        <div className="marketerMenubar">
            <div className="logo">
                <img src={Logo} alt="logo" />
            </div>
            <div className="menus">
                <ul>
                    {navLinks.map(({ to, label, icon, exact }) => (
                        <li key={to} style={{ fontWeight: isActive(to, exact) ? 700 : 400 }}>
                            {icon}
                            <Link
                                to={to}
                                style={{
                                    textDecoration: "none",
                                    color: isActive(to, exact) ? "#132238" : "#444",
                                    fontWeight: "inherit"
                                }}
                            >
                                {label}
                            </Link>
                        </li>
                    ))}
                    <hr />
                    <li onClick={handleLogout} style={{ cursor: "pointer", color: "#dc3545" }}>
                        <FiLogOut /> Logout
                    </li>
                </ul>
            </div>
            <div className="currentUser" style={{ backgroundColor: "#E0A75E", height: "28px", marginTop: "30px" }}>
                <h6><FaUserCircle /> Hello, {userName || "Agent"}</h6>
            </div>
        </div>
    );
}

export default MarketerMenu;
